export enum SapiParam {
    EMAIL = '{email}',
    PASSWORD = '{password}',
    PAYMENT_ID = '{paymentId}',
    PRODUCT_ID = '{productId}',
    SUSBCRIPTION_ID = '{subscriptionId}',
    USER_ID = '{userId}'
}